import React, { useState } from "react";
import ModalChuyenNhapRutQuy from "../ModalChuyenNhapRutQuy";

const BtnChuyenQuy = ({ onReload, RoleQuyTienMatDuyetQuy }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <a
        type="button"
        onClick={() => setShow(true)}
        style={{ fontSize: 15 }}
        className="btn"
      >
        <span>
          <img
            src="/app-assets/images/icon-chuyen-quy.png"
            style={{ marginRight: "6px" }}
            alt="Chuyển quỹ"
          />
          Chuyển quỹ
        </span>
      </a>

      {show && (
        <ModalChuyenNhapRutQuy
          show={show}
          onHide={() => setShow(false)}
          mode={{ type: 50 }} // Type 50: Chuyển quỹ
          onSuccess={() => {
            setShow(false);
            if (onReload) onReload();
          }}
          RoleQuyTienMatDuyetQuy={RoleQuyTienMatDuyetQuy}
        />
      )}
    </>
  );
};
export default BtnChuyenQuy;
